import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { DatePicker } from 'components/atoms/date-picker';
import { Form } from 'components/atoms/form';
import { useTranslation } from 'hooks/use-translation';
import { Props } from './types';

const StyledDatePicker = styled(DatePicker)`
  width: 100%;
`;

export const StartDateFormItem: FC<Props> = ({ field }) => {
  const requiredMessage = useTranslation('input.required');

  return (
    <Form.Item
      {...field}
      data-cy="project-template-form-item-start-date"
      name={[field.name, 'startDate']}
      fieldKey={[field.fieldKey, 'startDate']}
      rules={[
        {
          required: true,
          message: requiredMessage,
        },
      ]}
      label={<FormattedMessage id="projects.phase.import.start_date" />}
    >
      <StyledDatePicker />
    </Form.Item>
  );
};
